// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"FrontpageBanner_imgWrapper__vKpew","img":"FrontpageBanner_img__rBWV9"};